import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  FavoriteMilitaryOccupation,
  FavoriteMilitaryOccupationGQL,
  FavoriteMilitaryOccupationsGQL,
  FavoriteOccupationsGQL,
  OccupationCard,
  UnfavoriteMilitaryOccupationGQL,
  UpdateReclassifyingGQL,
  UserReclassifying,
  UserReclassifyingGQL
} from '@cpd-app/generated';
import { map } from 'rxjs/operators';
import {
  UpdateFavoriteOccupationGQL,
  UnfavoriteOccupationGQL
} from '@cpd-app/generated';
import { FavoriteOccupationMapper } from '@cpd-app/core-module/mappers';

@Injectable({
  providedIn: 'root'
})
export class FavoriteOccupationsService {
  constructor(
    private favoriteOccupationsGQL: FavoriteOccupationsGQL,
    private updateFavoriteOccupationGQL: UpdateFavoriteOccupationGQL,
    private unfavoriteOccupationGQL: UnfavoriteOccupationGQL,
    private favoriteMilitaryOccupationsGQL: FavoriteMilitaryOccupationsGQL,
    private favoriteMilitaryOccupationGQL: FavoriteMilitaryOccupationGQL,
    private unfavoriteMilitaryOccupationGQL: UnfavoriteMilitaryOccupationGQL,
    private updateReclassifyingGQL: UpdateReclassifyingGQL,
    private userReclassifyingGQL: UserReclassifyingGQL
  ) {}

  public getFavoriteOccupations(): Observable<OccupationCard[]> {
    return this.favoriteOccupationsGQL.fetch().pipe(
      map((results) => {
        return (results?.data?.favoriteOccupations || [])?.map((item) =>
          FavoriteOccupationMapper.toOccupationCard(item)
        );
      })
    );
  }

  public addFavoriteOccupation(
    onetCode: string,
    jobId: number
  ): Observable<OccupationCard> {
    return this.updateFavoriteOccupationGQL
      .mutate({
        onetCode: onetCode,
        jobId: jobId
      })
      .pipe(
        map((result) => {
          return {
            ...FavoriteOccupationMapper.toOccupationCard(
              result?.data?.favoriteOccupation.favoriteOccupation
            )
          };
        })
      );
  }

  public removeFavoriteOccupation(
    onetCode: string,
    jobId: number
  ): Observable<string> {
    return this.unfavoriteOccupationGQL
      .mutate({
        onetCode: onetCode,
        jobId: jobId
      })
      .pipe(
        map((result) => {
          return result?.data?.unfavoriteOccupation.message;
        })
      );
  }

  public getFavoriteMilitaryOccupations(): Observable<
    FavoriteMilitaryOccupation[]
  > {
    return this.favoriteMilitaryOccupationsGQL
      .fetch()
      .pipe(map((results) => results?.data?.favoriteMilitaryOccupations));
  }

  public addFavoritemilitaryOccupation(
    mocCode: string,
    mocTitle: string
  ): Observable<FavoriteMilitaryOccupation> {
    return this.favoriteMilitaryOccupationGQL
      .mutate({
        mocCode,
        mocTitle
      })
      .pipe(
        map(
          (result) =>
            result?.data?.favoriteMilitaryOccupation.favoriteMilitaryOccupation
        )
      );
  }

  public removeFavoriteMilitaryOccupation(
    mocCode: string,
    mocTitle: string
  ): Observable<boolean> {
    return this.unfavoriteMilitaryOccupationGQL
      .mutate({
        mocCode,
        mocTitle
      })
      .pipe(
        map((result) => result?.data?.unfavoriteMilitaryOccupation.success)
      );
  }

  public updateReclasyfying(
    transitionfrommilitary: boolean,
    stayincurrent: boolean
  ): Observable<UserReclassifying> {
    return this.updateReclassifyingGQL
      .mutate({
        transitionfrommilitary,
        stayincurrent
      })
      .pipe(
        map((result) => result?.data?.updateReclassifying.userReclassifying)
      );
  }

  public userReclassifying(): Observable<UserReclassifying> {
    return this.userReclassifyingGQL
      .fetch()
      .pipe(
        // The second hop needs guarding too: a visitor with no session gets
        // `userReclassifying: null`, and the unguarded read threw a TypeError
        // that surfaced as an error dialog on the public portfolio page.
        map((result) => result?.data?.userReclassifying?.userReclassifying)
      );
  }
}
